import React from 'react';
import ReactDOM from "react-dom";
import HelpComponent from '../HelpComponent';

class Acute3DOption extends React.Component{
    constructor(){
        super();
        this.state={
            isSettingOpen:false,
            cover : "null",
            helpMode : "None"
        };
    }
    deleteLayerList(layer){
        const Layer = {
            TITLE:layer.layerName,
            TYPE:layer.layerType
        };
        this.props.deleteLayerList(Layer);
    }
    gotoLayer(){
        var Acute3DLayer = this.props.layer.layerHandel;
        Acute3DLayer.goto();
    }
    settingOpen(){
        this.setState({ isSettingOpen: !this.state.isSettingOpen });
    }
    coverChange(event){
        var cover = event.target.value;
        var Acute3DLayer = this.props.layer.layerHandel;
        if(cover === "null"){
            Acute3DLayer.setOverlayName();
            window.main.OView.updateScreen();
        }            
        else{
            Acute3DLayer.setOverlayName(cover);
            window.main.OView.updateScreen();
        }            
        this.setState({cover : cover});
    }
    onHelpClick(mode){
        this.setState({helpMode:mode})
    }
    render(){
        const LayerList_2D = this.props.LayerList_2D;
        const Layer = this.props.layer;
        if(this.state.helpMode === "Acute3DHelp" ){
            ReactDOM.render(<HelpComponent videoSrc="https://www.youtube.com/embed/1xkg_otY5Vs" onHelpClick={(e)=>this.onHelpClick(e)} />,document.getElementById('Help'));
        }   
        else if(this.state.helpMode === "None"){
            ReactDOM.unmountComponentAtNode(document.getElementById('Help'));      
        }
        return(
            <div className="ts accordion item">
                <div className="ts grid">
                    <div className="ts ten wide column"  style={{alignSelf: 'center'}}>
                        <div className="ts grid">
                            <div className="ts two wide column">
                                <i className="large find icon"></i>
                            </div>
                            <div className="ts fourteen wide column" style={{alignSelf: 'center'}}>
                                <h6 className="layerNameCSS">{Layer.layerName}
                                    <button className="ts circular pulsing mini icon button" style={{fontSize:"10px"}} onClick={(e)=>this.onHelpClick("Acute3DHelp")}>
                                        <i className="help small icon" style={{color:"#919191"}}></i>
                                    </button>
                                </h6>
                            </div>
                        </div>                      
                    </div>
                    <div className="ts two wide column" style={{cursor:"pointer"}} onClick={(e)=>this.deleteLayerList(Layer)} data-tooltip-position="top center" data-tooltip-type="label" data-tooltip="關閉圖層">
                        <i className="large remove circle outline icon"></i>
                    </div>
                    <div className="ts two wide column" style={{cursor:"pointer"}} onClick={(e)=>this.gotoLayer()} data-tooltip-position="top center" data-tooltip-type="label" data-tooltip="前往圖層位置">
                        <i className="large marker icon"></i>
                    </div>
                    <div className="ts two wide column" style={{cursor:"pointer"}} onClick={(e)=>this.settingOpen()} data-tooltip-position="top center" data-tooltip-type="label" data-tooltip="圖層設定">
                        <i className="large setting icon"></i>
                    </div>
                </div>
                {
                    this.state.isSettingOpen?
                    <div className="ts very narrow container segment" >                        
                        <div className="ts grid">
                            <div className="ts ten wide column" style={{alignSelf: 'center'}}>
                                <h6 className="layerNameCSS">影像披覆：</h6>
                            </div>
                            <div className="ts six wide column">
                                <select className="ts borderless basic dropdown" onChange={(e)=>this.coverChange(e)} value={this.state.cover} style={{width:"100%"}}>
                                    <option value="null">無</option>
                                    {
                                        LayerList_2D.map(
                                            (layer)=>
                                                <option value={layer.layerName}>{layer.layerName}</option> 
                                        )
                                    }
                                </select>
                            </div>
                        </div>
                    </div> : null
                }
                
            </div>
        );
    }
}
class Acute3DLayer extends React.Component{
    constructor(){
        super();
        this.state = {
            isChecked:false,
            Acute3DLayer:{}
        };   
        this.Acute3DLayerChecked = this.Acute3DLayerChecked.bind(this);      
    }
    componentDidUpdate(){
        if(this.props.deleteList.layerName === this.props.layer.TITLE){
            let isChecked = this.state.isChecked;
            if(isChecked){
                window.main.OView.removeLayer(this.state.Acute3DLayer);
                window.alertify.error("已關閉圖層："+this.props.layer.TITLE);
                isChecked = !isChecked;
                this.setState({isChecked:isChecked,Acute3DLayer:{}});
            }            
        }
    }
    Acute3DLayerChecked(layer){
        let isChecked = this.state.isChecked;
        const layerThis = this;             
        if (!isChecked) {
            window.main.OView.addAcute3DLayer({
                url: window.LOCAL_SERVER.URL,
                identifier: layer.ID,
                urlTemplate: window.LOCAL_SERVER.URLTemplate,
                callback: function (e, Acute3DLayer)
                {
                    if (e)
                    {
                        // Set Offset
                        if (layer.OFFSET != null)
                        {
                            Acute3DLayer.setOffset(layer.OFFSET.x, layer.OFFSET.y, layer.OFFSET.z);
                        }

                        // Set Location
                        if (layer.LOCATION != null)
                        {
                            var Pos = new window.Geo3DPoint(layer.LOCATION.POS.x, layer.LOCATION.POS.y, layer.LOCATION.POS.z);
                            var V = new window.Geo3DPoint(layer.LOCATION.V.x, layer.LOCATION.V.y, layer.LOCATION.V.z);
                            var Up = new window.Geo3DPoint(layer.LOCATION.UP.x, layer.LOCATION.UP.y, layer.LOCATION.UP.z);
                            var Camera = new window.ov.Camera(Pos, V, Up);
                            window.main.OView.gotoCamera(Camera, true);
                        }
                        else
                        {
                            Acute3DLayer.goto();
                        }
                        
                        window.alertify.success("已開啟圖層："+layer.TITLE);
                        layerThis.props.setOpenLayer(layer,Acute3DLayer);                        
                        isChecked = !isChecked;
                        layerThis.setState({isChecked:isChecked,Acute3DLayer:Acute3DLayer});
                    }
                    else if(!e){
                        window.alertify.error("連結不到圖層:："+layer.TITLE);
                    }
                }
            });                  
        }
        else{
            window.main.OView.removeLayer(this.state.Acute3DLayer);
            layerThis.props.deleteLayer(layer);
            window.alertify.error("已關閉圖層："+layer.TITLE);
            isChecked = !isChecked;    
            layerThis.setState({isChecked:isChecked,Acute3DLayer:{}});        
        }                      
    }    
    render(){
        const layer = this.props.layer;
        return(
            <div className="ts checkbox">
                <input type="checkbox" name="Acute3DLayer" id={layer.TITLE} checked={this.state.isChecked} onChange={(e)=>this.Acute3DLayerChecked(layer)}></input>
                <label htmlFor={layer.TITLE}>{layer.TITLE}</label>
            </div>
        );
    }
}

export  {Acute3DLayer,Acute3DOption};